var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var DiscountBadge = function (_a) {
    var promoTitle = _a.promoTitle;
    return (_jsx("div", __assign({ className: "absolute w-[90px] md:w-[140px] inset-0 top-5 left-[154px] md:top-[56px] md:left-[308px] z-10" }, { children: _jsx("div", __assign({ className: "bg-chew-toy-450 border-2 border-shoe rounded-[6px] px-3 py-2 text-xs-head-m md:text-xs-head-d font-display" }, { children: promoTitle })) })));
};
export default DiscountBadge;
